import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getData } from "../store/utils";
import Swal from "sweetalert2";
import { useDebounce } from 'use-debounce';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "none",
    padding: "0px",
    minWidth: "90%",
    maxWidth: "90%",
  },
};

function PurchaseReceivesList() {
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [text, setText] = useState('');
  const [value] = useDebounce(text, 1000);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  async function getPurchaseOrder({ page = 1, pageSize = 20, vendorName = "", search = "", isLoadMore = false }) {
    setIsLoadingOn(true);
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    // if (vendorName) params.append("vendorName", vendorName);
    params.append("page", page);
    params.append("pageSize", pageSize);
    // 'inventory/getReceiveOrder?vendorName=Yashod&companyName=yash&page=1&pageSize=5&purchaseOrder=PU&purchaseReceive=0'
    const tempData = await getData(`inventory/getReceiveOrder?${params.toString()}`);
    setIsLoadingOn(false);

    if (tempData?.statusCode === 200) {
      const records = tempData?.data?.records || [];

      //   if (Array.isArray(records)) {
      //     setOrderList(records);
      //   } else {
      //     setOrderList([]);
      //   }
      // } else {
      //   setOrderList([]);
      //   Swal.fire({
      //     title: "Error!",
      //     text: tempData?.data?.errors?.msg || "Something went wrong!!!"
      //   });
      // }
      setOrderList(prev => {
        if (isLoadMore) {
          return [...prev, ...records]; // Append for infinite scroll
        } else {
          return records; // Reset list for new search or first load
        }
      });

      return {
        hasMore: records.length === pageSize,
      };
    } else {
      setOrderList([]);
      Swal.fire({
        title: "Error!",
        text: tempData?.data?.errors?.msg || "Something went wrong!!!",
      });
      return { hasMore: false };
    }
  }


  // useEffect(() => {
  //   // Initial load - fetch all purchase orders
  //   getPurchaseOrder('');
  // }, []);

  // Debounced search
  useEffect(() => {
      setIsSearching(value !== ''); // set true if searching
      getPurchaseOrder(value);      // fetch data based on debounced value
    }, [value]);

  useEffect(() => {
    setPage(1);
    getPurchaseOrder({ page: 1, search: value });
  }, [value]);

  const filterPurchaseOrder = (e) => {
    setText(e.target.value);
  }

  useEffect(() => {
    const handleScroll = () => {
      const bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight;

      if (bottom && hasMore && !isLoadingOn) {
        const nextPage = page + 1;
        setPage(nextPage);
        getPurchaseOrder({ page: nextPage, search: value, isLoadMore: true });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, hasMore, value, isLoadingOn]);


  return (
    <div className="purchaseOrderSec purchaseListSec">
      <div>
        {isLoadingOn ? <Loader /> : ""}

        {/* {Array.isArray(orderList) && orderList.length > 0 && ( */}
          <div className="filter mb-3">
            <div className="row">
              <div className="col-sm-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search in Purchase Order"
                  // onChange={(e) => filterPurchaseOrder(e)}
                  onChange={(e) => setText(e.target.value)}
                />
              </div>
            </div>
          </div>
        {/* )} */}
        <div className="d-flex justify-content-between align-items-center">
          <h4>All Purchase Receive</h4>
          <div>
            {/* <button className="btn btn-outline-primary transitbtnbg">In Transit Receives</button> */}
            <Link to={'/purchaseReceives'}><button className="btn btn-primary mx-2">
              + New
            </button>
            </Link>
            {/* <button className="btn btn-light">⋮</button> */}
          </div>
        </div>
        <div className="purchaseorderTable">
          <div className="table-container">
            <div className="table-scroll">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "80px" }} className="checkbox-cell"><input type="checkbox" /></th>
                    <th style={{ width: "200px" }}>DATE</th>
                    <th style={{ width: "300px" }}>PURCHASE RECEIVE#</th>
                    <th style={{ width: "200px" }}>PURCHASE ORDER</th>
                    <th style={{ width: "300px" }}>VENDOR NAME</th>
                    <th style={{ width: "200px" }}>STATUS</th>
                    <th style={{ width: "300px" }}>BILLED</th>
                    <th style={{ width: "300px" }}>QUANTITY </th>

                  </tr>
                </thead>
                <tbody>
                  {orderList && orderList.length > 0 ? (
                    orderList.map((item, index) => (
                      <tr key={index} className="table-row">
                        <td className="checkbox-cell"><input type="checkbox" /></td>
                        <td>{item?.purchaseDate}</td>
                        <td><Link to={`/purchasereceiveDetails/${item?.purchaseReceiveId}`} className="vendor-name">{item?.purchaseReceive}</Link></td>
                        <td>{item?.purchaseOrder}</td>
                        <td>{item?.vendorName}</td>
                        <td>{item?.statusName}</td>
                        <td>{item?.billed}</td>
                        <td>{item?.Quantity}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center text-gray-500 py-4">
                        No Purchase Receives to display!
                      </td>
                    </tr>
                  )}

                </tbody>
              </table>
            </div>
          </div>
        </div>



      </div>
    </div>
  );
}

export default PurchaseReceivesList;
